import { useEffect, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro"

import HttpManager from "../../services/HttpManager"
import UnderlineHeading from "../underlineHeading"

import "./matriculaDelHorario.css"

/*
	Quien esta matriculado en este horario, dentro de la ficha del horario.

	Esteban (2026-09-21): "no entiendo porque esta split lo de ver el horario de lo
	de la matricula del horario, creo que deberia ser una sola vista".

	Aqui va la LECTURA -- quien esta, con que saldo -- que es a lo que se entra el
	99% de las veces. Dar de alta, cambiar de estatus o mover kits sigue en la
	pantalla de matricula, a un boton de distancia, porque es un formulario con su
	propio guardado y meterlo dentro de otro formulario es pedir un error caro.
*/

interface Props
{
	campusId    : number
	scheduleId  : number
	/** Abre la pantalla de matricula. Si no viene, no se ensena el boton. */
	onMatricula? : () => void
	idleLocked?  : boolean
}

const MatriculaDelHorario = ({campusId, scheduleId, onMatricula, idleLocked} : Props) =>
{
	const http = HttpManager.getInstance()

	const [alumnos, setAlumnos] = useState<any[] | null>(null)
	const [error, setError]     = useState<string | null>(null)

	useEffect
	(
		() =>
		{
			let cancelado = false

			const traer = async () =>
			{
				try
				{
					const respuesta = await http.enrollmentService.searchEnrollments(campusId, scheduleId)

					if(cancelado) return

					const datos = respuesta.data
					const lista = Array.isArray(datos) ? datos : (datos?.enrollments || [])

					setAlumnos(lista)
				}
				catch(err : any)
				{
					if(!cancelado) setError("La lista de alumnos no pudo cargarse.")
					console.error(err)
				}
			}

			traer()

			return () => {cancelado = true}
		},
		[campusId, scheduleId]
	)

	const activos = (alumnos || []).filter((alumno : any) => alumno)

	return <div className="waMh">
		<UnderlineHeading name={"Matrícula"} />
		<div className="waMhBarra">
			<span className="waMhCuenta">
				{
					alumnos === null
						? "Cargando…"
						: (activos.length === 1 ? "1 alumno matriculado" : activos.length + " alumnos matriculados")
				}
			</span>
			{
				!onMatricula ? null : <button type="button" className="waMhAbrir" disabled={idleLocked} onClick={onMatricula}>
					<FontAwesomeIcon icon={solid("user-plus")} />
					<span>
						Abrir matrícula
					</span>
				</button>
			}
		</div>
		{
			alumnos === null ? null :
			(
				activos.length < 1
						?
					<p className="waMhVacio">
						Todavía no hay nadie matriculado en este horario.
					</p>
						:
					<ul className="waMhLista">{
						activos.map((alumno : any) =>
						{
							const saldo   = alumno.generalBalance
							const vencido = saldo ? +saldo.expiredMonthlyBalance.value : 0

							return <li key={"MH_" + (alumno.enrollmentId || alumno.id)}>
								<span className="waMhQuien">
									<span className="waMhNombre">
										{[alumno.firstName, alumno.lastName].filter(Boolean).join(" ")}
									</span>
									<span className="waMhCorrelativo">
										{alumno.correlative}
									</span>
								</span>
								<span className="waMhEstado">
									{alumno.enrollmentStatus}
								</span>
								{
									!saldo ? null : <span className={vencido > 0 ? "waMhSaldo debe" : "waMhSaldo"}>
										{
											vencido > 0
												? "Vencido " + saldo.expiredMonthlyBalance.moneyFormat
												: "Al corriente"
										}
									</span>
								}
							</li>
						})
					}</ul>
			)
		}
		{!error ? null : <p className="waMhError">{error}</p>}
	</div>
}

export default MatriculaDelHorario
